import styled from 'styled-components';

import { LinkButton } from 'components/ui/Button';
import PaymentsSummary from 'components/shared/PaymentsSummary';
import { ButtonContent } from 'components/ui/Button/Button.styles';
import { Column } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const StyledLinkButton = styled(LinkButton)`
  color: ${colours.Shades.BlueShade40};

  ${ButtonContent} {
    > :first-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const StyledPaymentsSummary = styled(PaymentsSummary)`
  box-shadow: none;
`;

export const StyledBookingFee = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const StyledBookingFeeBody = styled(Column)`
  padding: 16px;
`;

export const StyledSummary = styled('div')`
  padding: 0 0 15px 0;

  &:last-child {
    padding: 0;
  }
`;

export const StyledParagraph = styled('p')`
  font-size: 13px;
  padding: 0px;
  margin: 0px;
  display: block;
`;

export const StyledAlertWrapper = styled.div`
  margin: 8px 0;
`;

export const StyledRowHeader = styled('h2')`
  font-size: 28px;
  color: ${colours.Greyscale.CharcoalGrey};
  font-weight: normal;
`;
